// extracted by mini-css-extract-plugin
module.exports = {"stockRow":"StockListModal_stockRow__bJ44q","searchInput":"StockListModal_searchInput__YoufA","clearIcon":"StockListModal_clearIcon__8VGU9"};